import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import Footer from '../components/Footer';

const CookiePolicyPage = () => (
  <div className="privacy-page min-h-screen" data-testid="cookie-policy-page">
    <Helmet>
      <title>Політика cookies — CIMM Computers Одеса</title>
      <meta name="description" content="Політика використання файлів cookies на сайті сервісного центру CIMM Computers." />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href="https://cimm.od.ua/cookies" />
    </Helmet>

    <header className="cyber-header fixed top-0 left-0 right-0 z-50">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <div className="text-2xl font-bold neon-text">CIMM</div>
          <div className="text-sm text-gray-400 hidden md:block">Комп'ютери та Ремонт</div>
        </Link>
        <a href="tel:+380974178788" className="neon-text font-semibold">+38 097 417 8788</a>
      </div>
    </header>

    <section className="pt-32 pb-16 px-4 dark-section">
      <div className="container mx-auto max-w-4xl relative z-10">
        <div className="text-center mb-12">
          <div className="w-16 h-16 bg-gradient-to-br from-orange-500/20 to-orange-600/20 rounded-xl flex items-center justify-center mx-auto mb-4">
            <Cookie className="w-8 h-8 text-orange-500 icon-glow" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Політика <span className="neon-text">cookies</span>
          </h1>
        </div>

        <div className="glass-card p-8 space-y-6 text-gray-300 leading-relaxed" data-testid="cookie-content">
          <div>
            <h2 className="text-2xl font-bold text-white mb-3">Що таке cookies</h2>
            <p>
              Cookies — це невеликі текстові файли, які зберігаються у вашому браузері під час відвідування сайту.
              Вони допомагають нам розпізнавати ваш пристрій, робити роботу з сайтом зручнішою та аналізувати
              статистику відвідувань.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-3">Які cookies ми використовуємо</h2>
            <ul className="list-disc ml-6 space-y-2">
              <li>
                <strong>Необхідні (functional)</strong> — для роботи сайту (сесії, налаштування теми, кошик).
                Ці cookies не потребують згоди.
              </li>
              <li>
                <strong>Аналітичні</strong> — Google Analytics, Meta Pixel — для розуміння поведінки користувачів
                і покращення сайту.
              </li>
              <li>
                <strong>Рекламні</strong> — Google Ads, Facebook Pixel — для показу релевантної реклами наших
                послуг у пошуку та соціальних мережах.
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-3">Як відмовитися від cookies</h2>
            <p>
              Ви можете у будь-який момент вимкнути cookies у налаштуваннях вашого браузера. Слід врахувати, що
              деякі функції сайту можуть працювати некоректно без cookies. Ви також можете керувати
              рекламними cookies через інструменти Google
              (<a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer" className="text-orange-400 hover:underline">adssettings.google.com</a>)
              та Meta
              (<a href="https://www.facebook.com/adpreferences" target="_blank" rel="noopener noreferrer" className="text-orange-400 hover:underline">facebook.com/adpreferences</a>).
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-3">Контакти</h2>
            <p>
              З питань обробки cookies звертайтеся: <a href="mailto:info@cimm.od.ua" className="text-orange-400 hover:underline">info@cimm.od.ua</a>,
              {' '}<a href="tel:+380974178788" className="text-orange-400 hover:underline">+38 097 417 8788</a>.
            </p>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
);

export default CookiePolicyPage;
